<script setup lang="ts">
import type LxcError from "~/core/models/LxcError.class";
import {
  Filters,
  type FilterSelectionValue,
  type FiltersSelection,
} from "~/core/models/filters";
import { PATH_ORGANIZATIONS_ID_SETTINGS } from "~/modules/organization/constants";
import type { OrganizationV2 } from "~/modules/organization/models/OrganizationV2.interface";

const router = useRouter();
const { t } = useI18n();

const props = defineProps<{
  organizations?: OrganizationV2[];
  search: (replaceHistory?: boolean) => Promise<void>;
  onSearch: (callback: () => void, executeCallback?: boolean) => void;
  filters: FiltersSelection;
  setFilter: (
    filter: Filters,
    value: FilterSelectionValue,
    fallbackValue?: FilterSelectionValue | undefined,
  ) => void;
  isLoading: boolean;
  error?: LxcError;
}>();

const searchQuery = computed({
  get() {
    return (props.filters.get(Filters.ORGANIZATION_NAME) ?? "") as string;
  },
  set(searchQuery) {
    props.setFilter(Filters.ORGANIZATION_NAME, searchQuery);
  },
});

function onSettingsClick(organizationCode: number) {
  router.push({
    name: PATH_ORGANIZATIONS_ID_SETTINGS,
    params: { id: organizationCode },
  });
}
</script>

<template>
  <div class="mb-6 w-1/2">
    <search-bar
      v-model:search-query="searchQuery"
      :search-placeholder="t('filters.search')"
      @clear="search"
      @search="search"
    />
  </div>
  <container-component :is-loading="isLoading" :error="error" :px="0" :py="0">
    <card-list
      v-if="props.organizations && props.organizations?.length > 0"
      :item-list="props.organizations"
      @click:item="onSettingsClick($event.code)"
    >
      <!-- Define slot with type-safe props -->
      <template #cardContent="{ item: organization }: { item: OrganizationV2 }">
        <entity-card-content
          :entity-name="organization.name"
          :device-count="organization.deviceCount"
          @click:settings="onSettingsClick(organization.code)"
        />
      </template>
    </card-list>
  </container-component>
</template>
